var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "recommendations-setting-enabled" } }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.enabled,
          expression: "enabled"
        }
      ],
      staticClass: "checkbox",
      attrs: {
        id: "recommendationsEnabledToggle",
        checked: "checked",
        type: "checkbox",
        name: "enabled"
      },
      domProps: {
        checked: Array.isArray(_vm.enabled)
          ? _vm._i(_vm.enabled, null) > -1
          : _vm.enabled
      },
      on: {
        change: function($event) {
          var $$a = _vm.enabled,
            $$el = $event.target,
            $$c = $$el.checked ? true : false
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v)
            if ($$el.checked) {
              $$i < 0 && (_vm.enabled = $$a.concat([$$v]))
            } else {
              $$i > -1 &&
                (_vm.enabled = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.enabled = $$c
          }
        }
      }
    }),
    _vm._v(" "),
    _c("label", { attrs: { for: "recommendationsEnabledToggle" } }, [
      _vm._v(_vm._s(_vm.t("recommendations", "Show recommendations")))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }